module.exports = __webpack_public_path__ + "static/media/mibole_bank.65f66693.png";